document.addEventListener('turbolinks:before-visit', function() {
  window.turbolinks_referer = location.href;
});

document.addEventListener('turbolinks:load', function() {
  if (window.turbolinks_referer) {
    if (window.ym) {
      ym(110754326, 'hit', location.href, {
        title: document.querySelector('title').text.trim(),
        referer: window.turbolinks_referer,
      });
    }
  }
});

window.dataLayer = window.dataLayer || [];
